require('base/handlebars');
require('base/ZCY');
require('base/handlebars-adv');
require('base/component').initialize();

const config = require('helper/config');

// 贵港站点代理机构链接改成外部链接
if (config.siteId == 29) {
  $('.ZCY-comp-nav [href*=ggcgAgent], .ZCY-comp-header-nav [href*=ggcgAgent] ').attr('href', 'http://zfcg.gxzf.gov.cn/gxcgAgency/index.html');
}

// 贵港站点代理机构链接改成外部链接
if (config.siteId == 79) {
  $('.ZCY-comp-nav [href*=lzcgAgent], .ZCY-comp-header-nav [href*=lzcgAgent] ').attr('href', 'http://zfcg.gxzf.gov.cn/gxcgAgency/index.html');
}

// 广西站点网上办事链接改成外部链接
if (config.siteId == 61) {
  $('.ZCY-comp-nav [href*=OnlineWork], .ZCY-comp-header-nav [href*=OnlineWork] ').attr('href', 'http://zwfw.gxzf.gov.cn/');
  $('.ZCY-comp-nav [href*=OnlineWork], .ZCY-comp-header-nav [href*=OnlineWork] ').attr('target', '_blank');
}
